import { SystemModule } from '@/core/types/SystemModule.ts'
import salesModule from '@/assets/images/sales_module.svg'
import { frontPaths } from '@/config/frontPaths.ts'
import collectionsModule from '@/assets/images/collections_module.svg'
import inventoryModule from '@/assets/images/inventory_module.svg'
import supportModule from '@/assets/images/support_module.svg'
import reportModule from '@/assets/images/reports_module.svg'
import learningModule from '@/assets/images/learnings_module.svg'
import configurationModule from '@/assets/images/configurations_module.svg'
import alliesModule from '@/assets/images/allies_module.svg'
import servicesModule from '@/assets/images/services_module.svg'
import insurersModule from '@/assets/images/insurers_module.svg'
import marketplaceModule from '@/assets/images/marketplace_module.svg'
import drawModule from '@/assets/images/draw_module.svg'

export const systemModulesConf: SystemModule[] = [
  {
    name: 'Ventas',
    systemName: 'sales',
    icon: salesModule,
    defaultPath: frontPaths.modules.sales.clients,
    views: [
      {
        name: 'Clientes',
        systemName: 'clients',
        permission: 'SALES_CLIENTS:LEER'
      },
      {
        name: 'Facturas por Recargas de Servicio',
        systemName: 'service-recharge-invoices',
        permission: 'REPORTS_RECHARGE_INVOICES:LEER'
      },
      {
        name: 'Weppa Flex',
        systemName: 'weppa-flex',
        permission: 'ALLY_ASSIGN_MISCELLANEOUS:LEER'
      }
    ]
  },
  {
    name: 'Cobranza',
    systemName: 'collections',
    icon: collectionsModule,
    defaultPath: frontPaths.modules.collections['pending-recharges'],
    views: [
      {
        name: 'Recargas pendientes',
        systemName: 'pending-recharges',
        permission: 'COLLECTIONS_PENDING_RECHARGE:LEER'
      },
      {
        name: 'Cuotas atrasadas',
        systemName: 'late-quotas',
        permission: 'COLLECTIONS_OVERDUE_QUOTES:LEER'
      }
    ]
  },
  {
    name: 'Inventario',
    systemName: 'inventory',
    icon: inventoryModule,
    defaultPath: frontPaths.modules.inventory.apples,
    views: [
      {
        name: 'Inventario Apple',
        systemName: 'apples',
        permission: 'INVENTORY_APPLE_INVENTORY:LEER'
      },
      {
        name: 'Inventario Productos',
        systemName: 'products',
        permission: 'INVENTORY_PRODUCT_INVENTORY:LEER'
      },
      {
        name: 'Inventario Automotriz',
        systemName: 'automotive',
        permission: 'INVENTORY_AUTOMOTIVE_INVENTORY:LEER'
      }
    ]
  },
  {
    name: 'Soporte',
    systemName: 'support',
    icon: supportModule,
    defaultPath: frontPaths.modules.support['release-request'],
    views: [
      {
        name: 'Liberación por garantía',
        systemName: 'release-request',
        permission: 'SUPPORT_RELEASE_WARRANTY:LEER'
      },
      {
        name: 'Edición de cliente',
        systemName: 'client-edit-request',
        permission: 'SUPPORT_UPDATING_CLIENT:LEER'
      },
      {
        name: 'Edición de artículo',
        systemName: 'article-edit-request',
        permission: 'SUPPORT_UPDATING_PRODUCT:LEER'
      },
      {
        name: 'Cambio de artículo',
        systemName: 'article-change-request',
        permission: 'SUPPORT_CHANGING_PRODUCT:LEER'
      },
      {
        name: 'Reasignación de artículo',
        systemName: 'article-reassign-request',
        permission: 'SUPPORT_REASSIGN_PRODUCT:LEER'
      },
      {
        name: 'Eliminación de artículo',
        systemName: 'article-delete-request',
        permission: 'SUPPORT_DELETING_PRODUCT:LEER'
      }
    ]
  },
  {
    name: 'Reportes',
    systemName: 'reports',
    icon: reportModule,
    defaultPath: frontPaths.modules.reports['total-sales'],
    views: [
      {
        name: 'Ventas totales',
        systemName: 'total-sales',
        permission: 'REPORTS_TOTAL_SALES:LEER'
      },
      {
        name: 'Ventas en sucursales',
        systemName: 'sales-by-branch',
        permission: 'REPORTS_BRANCHES_SALES:LEER'
      },
      {
        name: 'Ventas por aliado',
        systemName: 'sales-by-ally',
        permission: 'REPORTS_ALLIES_SALES:LEER'
      },
      {
        name: 'Pagos automáticos',
        systemName: 'automatic-payments',
        permission: 'REPORTS_AUTOMATIC_PAYMENT:LEER'
      },
      {
        name: 'Pagos aprobados por empleados',
        systemName: 'approved-payments-by-employees',
        permission: 'REPORTS_EMPLOYED_PAYMENT:LEER'
      },
      {
        name: 'Recargas por aliado',
        systemName: 'recharge-by-ally',
        permission: 'REPORTS_ALLIES_RECHARGED:LEER'
      },
      {
        name: 'Artículos atrasados por aliado',
        systemName: 'ally-overdue-devices',
        permission: 'REPORTS_ALLIES_PENDING:LEER'
      },
      //Hidden by request
      // (since this view does not exist system doesn't allow rendering it)
      // {
      //   name: 'Artículos Apple atrasados',
      //   systemName: 'apple-devices-overdue',
      //   permission: 'REPORTS_APPLE_PENDING:LEER'
      // },
      {
        name: 'Pagos a aliados aprobados',
        systemName: 'approved-payments-to-ally',
        permission: 'REPORTS_ALLIES_PAYMENT:LEER'
      },
      {
        name: 'Listado de cuotas atrasadas',
        systemName: 'overdue-quotas-list',
        permission: 'REPORTS_OVERDUE_QUOTES_LIST:LEER'
      },
      {
        name: 'Productos pendientes',
        systemName: 'marketplace-ally-pending-products',
        permission: 'REPORTS_PENDING_PRODUCTS:LEER'
      },
      {
        name: 'Códigos de referidos',
        systemName: 'referral-codes',
        permission: 'REPORTS_REFERRAL_CDDES:LEER'
      },
      {
        name: 'Sucursales',
        systemName: 'branch-offices',
        permission: 'REPORTS_BRANCHES_DAYS_WHITOUT_SALES:LEER'
      },
      {
        name: 'Club Movistar',
        systemName: 'movistar-club',
        permission: 'REPORTS_CLUB_MOVISTAR_SALES:LEER'
      },
      {
        name: 'Resumen de crédito preasignado',
        systemName: 'preassigned-credit-summary',
        permission: 'REPORTS_PREASSIGNED_CREDIT_SUMMARY:LEER'
      },
      {
        name: 'Créditos refinanciados',
        systemName: 'credit-refinancing',
        permission: 'REPORTS_CREDIT_REFINANCING:LEER'
      },
      {
        name: 'Clientes Weppa Plus',
        systemName: 'weppa-plus-clients',
        permission: 'REPORTS_WEPPA_PLUS:LEER'
      },
      {
        name: 'Zona U',
        systemName: 'zone-u',
        permission: 'REPORTS_ZONA_U_SALES:LEER'
      },
      {
        name: 'CashOut',
        systemName: 'cashout',
        permission: 'REPORTS_CASHOUT:LEER'
      },
      {
        name: 'Geolocalización',
        systemName: 'geolocation',
        permission: 'REPORTS_MAPS:LEER'
      },
      {
        name: 'Motos asignadas',
        systemName: 'assigned-motorcycles',
        permission: 'REPORTS_ASSIGNED_MOTO:LEER'
      },
      {
        name: 'Recaudación consolidada de cuotas',
        systemName: 'quotes-collection',
        permission: 'REPORTS_COLLECTIONS:LEER'
      },
      {
        name: 'Recargas y servicios',
        systemName: 'cash-top-ups',
        permission: 'REPORTS_RECHARGE_CASH:LEER'
      }
    ]
  },
  {
    name: 'Enseñanza',
    systemName: 'teaching',
    icon: learningModule,
    defaultPath: frontPaths.modules.teaching.videosCategory,
    views: [
      {
        name: 'Categoría de Video',
        systemName: 'videosCategory',
        permission: 'TEACHING_VIDEO_CATEGORY:LEER'
      },
      {
        name: 'Configurar Video',
        systemName: 'videos',
        permission: 'TEACHING_VIDEO:ACTUALIZAR'
      },
      {
        name: 'Lista de Videos',
        systemName: 'videoList',
        permission: 'TEACHING_VIDEO:LEER'
      }
    ]
  },
  {
    name: 'Aliado',
    systemName: 'allies',
    icon: alliesModule,
    defaultPath: frontPaths.modules.allies.allies,
    views: [
      {
        name: 'Aliados',
        systemName: 'allies',
        permission: 'ALLY_ALLIES:LEER'
      },
      {
        name: 'Solicitudes de pago',
        systemName: 'payment-request',
        permission: 'ALLY_PAYMENT_REQUESTS:LEER'
      },
      {
        name: 'Corte diario',
        systemName: 'daily-cut',
        permission: 'ALLY_DAILY_CUT:LEER'
      },
      {
        name: 'Corte mensual',
        systemName: 'monthly-cut',
        permission: 'ALLY_MONTHLY_CUT:LEER'
      }
    ]
  },
  {
    name: 'Servicios',
    systemName: 'services',
    icon: servicesModule,
    defaultPath: frontPaths.modules.services.services,
    views: [
      {
        name: 'Servicios',
        systemName: 'services',
        permission: 'SERVICES_SERVICES:LEER'
      },
      {
        name: 'Corte diario',
        systemName: 'daily-cut',
        permission: 'SERVICES_DAILY_CUT:LEER'
      }
    ]
  },
  {
    name: 'Aseguradoras',
    systemName: 'insurers',
    icon: insurersModule,
    defaultPath: frontPaths.modules.insurers['service-centers'],
    views: [
      {
        name: 'Talleres',
        systemName: 'service-centers',
        permission: 'INSURANCE_WORKSHOP:LEER'
      },
      {
        name: 'Gestión de rentabilidades',
        systemName: 'rentability-configuration',
        permission: 'INSURANCE_WORKSHOP:LEER'
      },
      {
        name: 'Reclamos',
        systemName: 'claims',
        permission: 'INSURANCE_CLAIMS:LEER'
      }
    ]
  },
  {
    name: 'Marketplace',
    systemName: 'marketplace',
    icon: marketplaceModule,
    defaultPath: frontPaths.modules.marketplace.orders,
    views: [
      {
        name: 'Órdenes',
        systemName: 'orders',
        permission: 'MARKETPLACE_MARKETPLACE_ORDERS:LEER'
      },
      {
        name: 'Marketplaces',
        systemName: 'marketplaces',
        permission: 'MARKETPLACE_MARKETPLACE_ADMIN:LEER'
      },
      {
        name: 'Productos',
        systemName: 'products',
        permission: 'MARKETPLACE_MARKETPLACE_PRODUCTS:LEER'
      },
      {
        name: 'Descuentos',
        systemName: 'discounts',
        permission: 'MARKETPLACE_MARKETPLACE_PRODUCTS:LEER'
      },
      {
        name: 'Inventario',
        systemName: 'inventory',
        permission: 'MARKETPLACE_MARKETPLACE_INVENTORY:LEER'
      }
    ]
  },
  {
    name: 'Sorteos',
    systemName: 'draw',
    icon: drawModule,
    defaultPath: frontPaths.modules.draw.campaigns,
    views: [
      {
        name: 'Campañas',
        systemName: 'campaigns',
        permission: 'MARKETING_CAMPAIGN:LEER'
      },
      {
        name: 'Sorteos',
        systemName: 'draws',
        permission: 'MARKETING_DRAW:LEER'
      }
    ]
  },
  {
    name: 'Configuración',
    systemName: 'settings',
    icon: configurationModule,
    defaultPath: frontPaths.modules.settings.users,
    views: [
      {
        name: 'Usuarios',
        systemName: 'users',
        permission: 'SETTINGS_USERS:LEER'
      },
      {
        name: 'Categorías',
        systemName: 'categories',
        permission: 'SETTINGS_CATEGORIES:LEER'
      },
      {
        name: 'Marcas',
        systemName: 'brands',
        permission: 'SETTINGS_BRAND_MODEL:LEER'
      },
      {
        name: 'Localización',
        systemName: 'localizations',
        permission: 'SETTINGS_LOCATION:LEER'
      },
      {
        name: 'Tasa',
        systemName: 'tasas',
        permission: 'SETTINGS_EXCHANGE:LEER'
      },
      {
        name: 'Roles y permisos',
        systemName: 'roles',
        permission: 'SETTINGS_ROLES_PERMISSION:LEER'
      },
      {
        name: 'Importar',
        systemName: 'imports',
        permission: 'SETTINGS_IMPORTS:LEER'
      },
      {
        name: 'Promociones',
        systemName: 'promotions',
        permission: 'SETTINGS_PROMOTIONS:LEER'
      },
      {
        name: 'Métodos de pago',
        systemName: 'paymentMethods',
        permission: 'SETTINGS_PAYMENT_TYPE:LEER'
      },
      {
        name: 'Bancos',
        systemName: 'banks',
        permission: 'SETTINGS_BANK:LEER'
      },
      {
        name: 'Notificaciones',
        systemName: 'pushNotifications',
        permission: 'SETTINGS_PUSH_NOTIFICATIONS:LEER'
      },
      {
        name: 'Niveles',
        systemName: 'levels',
        permission: 'SETTINGS_LEVELS:LEER'
      },
      {
        name: 'Publicidad',
        systemName: 'publicity',
        permission: 'SETTINGS_PUBLICITY:LEER'
      }
    ]
  }
]
